<template>
  <div class="section-header">
    <p class="groupName text-left">
      {{ name }}
      <span v-if="requiredFlag" class="error-text">*</span>
    </p>
    <p v-if="description" class="gary-text text-left">{{ description }}</p>
  </div>
</template>
<script>
export default {
  props: ['name', 'description', 'requiredFlag']
};
</script>
<style scoped lang="less">
.section-header {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e8eaec;

  .error-text {
    color: red;
  }
}
</style>
